import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import './Wizard.less';

type Props = {
    sitemapUrls: string[];
    sitemapStartTime: string;
};

export default function SitemapImportProgress({ sitemapUrls, sitemapStartTime }: Props) {
    const [progress, setProgress] = useState(0);

    const startTimeSitemap = Date.parse(sitemapStartTime + 'Z');
    let elapsedTime = 0;

    useEffect(() => {
        const interval = setInterval(() => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            elapsedTime = Date.now() - startTimeSitemap;
            if (elapsedTime < 0 || isNaN(elapsedTime)) {
                elapsedTime = 0;
            }
            setProgress(Math.round((Math.atan(elapsedTime / 10000) / (Math.PI / 2)) * 100 * 100) / 100);

            if (progress >= 100) {
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [elapsedTime]);

    return (
        <div className="sitemap-import-progress-wrapper">
            <div className="sitemap-import-progress">
                <Alert
                    type="info"
                    showIcon
                    message="We're importing URLs from your sitemaps..."
                    description={
                        <span>
                            This process may take from few seconds to several minutes, depending on the number of sitemap files and the number of URLs in each
                            file. Feel free to leave this page - we'll email and notify you when it's complete.
                        </span>
                    }
                />

                <div className="progressbar">
                    <div className="counter">{progress.toFixed(2)}%</div>
                    <span
                        className="progress"
                        style={{ width: `${progress}%` }}
                    ></span>
                </div>

                <div className="discovered-sitemaps sitemap-success">
                    <h3>Discovered sitemaps:</h3>
                    <ul className="sitemaps-list">
                        {sitemapUrls.map((sitemapUrl, index) => (
                            <li
                                className="sitemap-url"
                                key={`sitemap-${index}`}
                            >
                                <a
                                    key={index}
                                    href={sitemapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {sitemapUrl}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
